import { render } from "./Kindergarten1cActReconciliationView.vue?vue&type=template&id=362766d7&ts=true"
import script from "./Kindergarten1cActReconciliationView.vue?vue&type=script&lang=ts"
export * from "./Kindergarten1cActReconciliationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__